import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import WorkspaceBillingPopupView from "views/workspace/WorkspaceBillingPopupView";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import Utils from "models/helper/Utils";
import ti18n from "i18n!nls/WorkspaceManagei18n";
import RSVP from "rsvp";

const WorkspaceBillingPopupController = Chaplin.Controller.extend({

    initialize: function(options) {
        _.extend(this, Backbone.Events);
        this._parentController = options.parentController;
    },

    getModel: function() {
        return this.model;
    },

    getView: function() {
        return this.view;
    },

    onPopupClosed: function() {
        // Cleanup if needed
    },

    handleManageBilling: async function() {
        const workspaceId = LocalStorageHelper.getInstance().getCurrentWorkspaceId();
        if (!workspaceId) {
            return;
        }

        try {
            const portalUrl = await TrebbleClientAPIHelper.getInstance().getWorkspaceBillingPortalUrl({
                workspaceId: workspaceId,
            });
            if (portalUrl) {
                window.open(portalUrl);
            }
        } catch (error) {
            console.error('Failed to open billing portal:', error);
            throw error;
        }
    },

    handleUpdateSeats: async function(newSeatCount) {
        const workspaceId = LocalStorageHelper.getInstance().getCurrentWorkspaceId();
        if (!workspaceId) {
            return;
        }

        var seatCount = parseInt(newSeatCount, 10);
        if (isNaN(seatCount) || seatCount < 1) {
            window.alertErrorMessage(window.getI18n(ti18n, "INVALID_SEAT_COUNT"));
            return;
        }

        try {
            await TrebbleClientAPIHelper.getInstance().updateWorkspaceSeatCount({
                workspaceId: workspaceId,
                newSeatCount: seatCount,
            });
            window.alertSuccessMessage(window.getI18n(ti18n, "SEATS_UPDATE_SUCCESS"));
        } catch (error) {
            console.error('Failed to update seats:', error);
            window.alertErrorMessage(window.getI18n(ti18n, "SEATS_UPDATE_ERROR"));
            throw error;
        }
    },

    handleCancelPlan: async function() {
        const workspaceId = LocalStorageHelper.getInstance().getCurrentWorkspaceId();
        if (!workspaceId) {
            return;
        }

        try {
            // Use the billing portal URL with cancellation context.
            // The user will complete cancellation in Stripe's portal UI,
            // so we do not show a success toast here.
            const portalUrl = await TrebbleClientAPIHelper.getInstance().getWorkspaceBillingPortalUrl({
                workspaceId: workspaceId,
                flowType: 'cancel',
            });
            if (portalUrl) {
                window.open(portalUrl);
            }
        } catch (error) {
            console.error('Failed to cancel plan:', error);
            window.alertErrorMessage(window.getI18n(ti18n, "CANCEL_ERROR"));
            throw error;
        }
    },

    _loadWorkspaceData: function() {
        const workspaceId = LocalStorageHelper.getInstance().getCurrentWorkspaceId();
        if (!workspaceId) {
            return RSVP.Promise.resolve(null);
        }

        return TrebbleClientAPIHelper.getInstance().getWorkspace({
            workspaceId: workspaceId,
        });
    },

    buildModelAndRenderView: function() {
        return this._loadWorkspaceData().then((function(workspaceData) {
            const workspace = workspaceData ? {
                name: workspaceData.name,
                planName: workspaceData.planName || window.getI18n(ti18n, "PLAN_NAME"),
                seatsUsed: workspaceData.seatsUsed || 0,
                seatsTotal: workspaceData.seatsTotal || 1,
                pricePerSeat: workspaceData.pricePerSeat ?? '--',
                billingCycle: workspaceData.billingCycle || 'monthly',
            } : null;

            const params = {
                workspace: workspace,
                onManageBilling: this.handleManageBilling.bind(this),
                onUpdateSeats: this.handleUpdateSeats.bind(this),
                onCancel: this.handleCancelPlan.bind(this),
                i18nModule: ti18n
            };

            this.view = new WorkspaceBillingPopupView(params);
            this.listenTo(this.view, "closed", this.onPopupClosed);

            this.view.render();
        }).bind(this)).catch((function(error) {
            console.error('Failed to load workspace billing:', error);

            const params = {
                workspace: null,
                onManageBilling: this.handleManageBilling.bind(this),
                onUpdateSeats: this.handleUpdateSeats.bind(this),
                onCancel: this.handleCancelPlan.bind(this),
                i18nModule: ti18n
            };

            this.view = new WorkspaceBillingPopupView(params);
            this.listenTo(this.view, "closed", this.onPopupClosed);

            this.view.render();
        }).bind(this));
    }
});

export default WorkspaceBillingPopupController;
